import React from 'react';

import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';

import { ContractTermName } from 'src/constants/contractTermHelpInfo';
import { AppContext } from 'src/contexts/appContext';

import { ContractTermHelpInfoTemplate } from '../ContractTermHelpInfoTemplate';

interface IContractTermInfoButtonProps {
    contractTermName: keyof typeof ContractTermName;
}

export const ContractTermInfoButton = ({ contractTermName }: IContractTermInfoButtonProps) => {
    const { setIsRightSideBarOpen, setRightSideBarContent } = React.useContext(AppContext);

    return (
        <Button
            type="link"
            size="small"
            onClick={() => {
                setIsRightSideBarOpen(true);
                setRightSideBarContent({
                    heading: 'Info',
                    mainBody: <ContractTermHelpInfoTemplate contractTermName={contractTermName} />
                });
            }}
        >
            <Icon tokens={infoKnockoutTokens} />
        </Button>
    );
};
